module.exports = __webpack_public_path__ + "static/viennahh-02d3c720051b70cb5d7f30c9cf3c170f.jpg";